var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"r-loading",rawName:"v-r-loading",value:(_vm.cardLoading),expression:"cardLoading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('CardList')],1),_c('Cash'),_c('DidiCash')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }